import React from 'react';

const Process = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Requirement Analysis',
      description: 'Understanding goals, constraints, and technical challenges.',
      icon: 'fas fa-search'
    },
    {
      number: '02',
      title: 'Design & Architecture',
      description: 'System design with scalability and performance in mind.',
      icon: 'fas fa-drafting-compass'
    },
    {
      number: '03',
      title: 'Development & Iteration',
      description: 'Agile execution with continuous feedback.',
      icon: 'fas fa-code'
    },
    {
      number: '04',
      title: 'Testing & Optimization',
      description: 'Performance, stability, and quality assurance.',
      icon: 'fas fa-vial'
    },
    {
      number: '05',
      title: 'Deployment & Support',
      description: 'Launch, monitoring, and long-term support.',
      icon: 'fas fa-rocket'
    }
  ];

  return (
    <section id="process" className="section">
      <div className="container">
        <h2 className="section-title">Why Choose CompileX</h2>
        <div className="process-timeline">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="process-number">{step.number}</div>
              <div className="process-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="process-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
